import theme from "../../theme";

export const outerChipSx = {
    justifyContent:"right",
};

export const innerChipSx = (value: boolean) => (
    {
        backgroundColor: value ? theme.palette.primary.dark : theme.palette.common.white,
        color: value ? theme.palette.common.white : theme.palette.error.main,
    }
)